import { useEffect } from 'react';

import MicrosoftAdsProduct from 'components/search/MicrosoftAdsProduct';

const MicrosoftAdsWrapper = ({ msftResults, msaImageParams, trackMicrosoftAdImpressions, makeMicrosoftAdClick, numMicrosoftAds, hydraMicrosoftSponsoredProducts, msftAdsToShow }) => {
  const { impressionUrl } = msftResults;

  /**
   * Here, we fire "impression" events when the component mounts to the screen
   * regardless if it is in-view, it's hidden via CSS (mobile screen), and whether or not the user is in msft
   */

  useEffect(() => {
    if (impressionUrl) {
      trackMicrosoftAdImpressions({ url: impressionUrl });
    }
  }, [impressionUrl, trackMicrosoftAdImpressions]);

  if (!hydraMicrosoftSponsoredProducts || !msftAdsToShow) {
    return null;
  }

  return msftResults.results.map((props, i) => {
    const product = { ...props, index: i, isSponsored: true };
    const { styleId, colorId } = product;
    return styleId && colorId && <MicrosoftAdsProduct
      key={`${styleId}-${colorId}`}
      product={product}
      numMicrosoftAds={numMicrosoftAds}
      trackMicrosoftAdImpressions={trackMicrosoftAdImpressions}
      makeMicrosoftAdClick={makeMicrosoftAdClick}
      msaImageParams={msaImageParams}
    />;
  });
};

export default MicrosoftAdsWrapper;
